import { IState } from '../../store';
import { EBookingFromDeveloperStatus } from '../../types/newbuildingBookedFromDeveloper';

export const selectIsBookingSuccess = (state: IState): boolean => {
  return state.newbuildingBookedFromDeveloper.status === EBookingFromDeveloperStatus.Success;
};
